<template>
    <div class="dis-detail">
        <div v-if="loaded" style="text-align: center;font-size: medium;">
            数据加载中...
        </div>
        <!-- <div v-else style="box-shadow: 0 15px 30px rgba(0,0,0,.3);padding: 0 0.2rem;border-radius: 15px;"> -->
        <div v-else>
            <!-- <div v-for="(item, index) in tableData" :key="index" class="detail-con">
                <div class="detail-item">
                    <div class="name-t">
                        {{ item.admin.username }}
                    </div>
                    <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                        <div class="total-t cur-s"
                            @click="openDialog(`${item.admin.username}总数`,{ task: task, admin_user: item.admin.id })">
                            总数:{{ item.dis }}
                        </div>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                        <div class="total-c cur-s" @click="openDialog(`${item.admin.username}有效沟通`,{ task: task, admin_user: item.admin.id, keyword: 'effect' })">
                            有效沟通:{{ item.effect }}
                        </div>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                        <div class="total-nc cur-s" @click="openDialog(`${item.admin.username}无效沟通`,{ task: task, admin_user: item.admin.id, keyword: 'not_effect' })">
                            无效沟通:{{ item.not_effect }}
                        </div>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                        <div class="total-not-call cur-s" @click="openDialog(`${item.admin.username}未联系`,{ task: task, admin_user: item.admin.id, keyword: 'not_con' })">
                            未联系:{{ item.dis - (item.effect + item.not_effect) }}
                        </div>
                    </el-tooltip>
                    <div class="total-p">
                        完成率:{{ (((item.effect + item.not_effect) / item.dis) * 100).toFixed(2) }}%
                        <i v-if="(((item.effect + item.not_effect) / item.dis) * 100).toFixed(2) == 100.00" class="el-icon-circle-check" style="color: #67C23A;"></i>
                    </div>
                </div>
            </div> -->
            <el-table :data="tableData" height="calc(100vh-3rem)" style="width: 100%;margin-top: 0.2rem" border size="mini"
                :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem'
        }" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
                <el-table-column prop="" label="序号" width="50" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="admin.username" label="姓名" width="" align="center">
                </el-table-column>
                <el-table-column prop="dis" label="总数" width="" align="center">
                    <template slot-scope="scope">
                        <!-- <div class="total-t cur-s" -->
                        <div class=""
                            @click="openDialog(`${scope.row.admin.username}总数`, { task: task, admin_user: scope.row.admin.id })">
                            <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                <el-link type="primary" class="el-link">
                                    {{ scope.row.dis }}
                                </el-link>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="effect" label="有效沟通" width="" align="center">
                    <template slot-scope="scope">
                        <!-- <div class="total-c cur-s" -->
                        <div class=""
                            @click="openDialog(`${scope.row.admin.username}有效沟通`, { task: task, admin_user: scope.row.admin.id, keyword: 'effect' })">
                            <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                <el-link type="success" class="el-link">
                                    {{ scope.row.effect }}
                                </el-link>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="not_effect" label="无效沟通" width="" align="center">
                    <template slot-scope="scope">
                        <!-- <div class="total-c cur-s" -->
                        <div class=""
                            @click="openDialog(`${scope.row.admin.username}无效沟通`, { task: task, admin_user: scope.row.admin.id, keyword: 'not_effect' })">
                            <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                <el-link type="warning" class="el-link">
                                    {{ scope.row.not_effect }}
                                </el-link>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="not_con" label="未联系" width="" align="center">
                    <template slot-scope="scope">
                        <!-- <div class="total-c cur-s" -->
                        <div class=""
                            @click="openDialog(`${scope.row.admin.username}未联系`, { task: task, admin_user: scope.row.admin.id, keyword: 'not_con' })">
                            <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                <el-link type="danger" class="el-link">
                                    {{ scope.row.dis - (scope.row.effect + scope.row.not_effect) }}
                                </el-link>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="完成率" width="" align="center">
                    <template slot-scope="scope">
                        <!-- <div class="total-c cur-s" -->
                        <div class=""
                            @click="">
                            <!-- <el-tooltip effect="dark" content="点击进入相应列表" placement="top">
                                <el-link type="warning" class="el-link">
                                    {{ scope.row.dis - (scope.row.effect + scope.row.not_effect) }}

                                </el-link>
                            </el-tooltip> -->
                            {{ (((scope.row.effect + scope.row.not_effect) / scope.row.dis) * 100).toFixed(2) }}%
                            <i v-if="(((scope.row.effect + scope.row.not_effect) / scope.row.dis) * 100).toFixed(2) == 100.00"
                                class="el-icon-circle-check" style="color: #67C23A;"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right;">
                <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                    @handleCurrentChange="handleCurrentChange" />
            </div>
        </div>

        <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog" fullscreen
            append-to-body center>
            <!-- <template v-slot:title>
                <span class="cal-tas-m-dia-title">
                    分配资源
                </span>
            </template> -->
            <call-task v-if="dialog" :t_keyword="t_keyword" :manage="manage" />
        </el-dialog>
    </div>
</template>

<script>
import CallTask from '../CallTask'
import PaginationCom from '../../../commonReform/PaginationCom'
export default {
    name: 'dis-detail',
    components: { CallTask, PaginationCom },
    props: {
        task: {
            required: true
        },
    },
    data() {
        return {
            tableData: [],
            loading: false,
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            loaded: true,
            dialog: false,
            t_keyword: '',
            manage: {},
        }
    },
    watch: {
        task: {
            immediate: true,
            handler(n) {
                if (n) this.loadTable()
            }
        }
    },
    methods: {
        loadTable() {
            this.tableData = []
            this.loaded = true
            this.$axios.get(`${this.hyperfHost}api/dis_detail/list?page=${this.npage}&perPage=${this.pageSize}`, {
                loadingClose: true,
                params: {
                    task: this.task,
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loaded = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        closeDialog() {
            this.t_keyword = ''
            this.manage = {}
        },
        beforeCloseDialog() {

        },
        openDialog(t, m) {
            this.t_keyword = t
            this.manage = m
            this.dialog = true
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
    },
    beforeDestroy() {

    }
}
</script>

<style scoped>
.dis-detail {
    /* background-color: #F2F6FC; */
    min-height: 100vh;
    padding: 0.2rem;
}

.dis-detail .detail-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0.2rem 0;
    box-sizing: border-box;
    font-size: medium;
    /* color: azure; */
}

.dis-detail .detail-con:nth-child(even) {
    color: #E6A23C;
}

.dis-detail .detail-con:nth-child(odd) {
    color: #409EFF;
}

.dis-detail .name-t {
    width: 1rem;
    text-align: right;
}

.dis-detail .total-t {
    width: 1.8rem;
    text-align: left;
}

.dis-detail .total-c {
    width: 2.1rem;
    text-align: left;
}

.dis-detail .total-nc {
    width: 2.0rem;
    text-align: left;
}

.dis-detail .total-not-call {
    width: 1.8rem;
    text-align: left;
}

.dis-detail .total-p {
    width: 3rem;
    text-align: left;
}

.dis-detail .el-drawer__wrapper>>>.el-drawer {
    overflow-y: auto;
}

.dis-detail .el-link {
    cursor: pointer;
}

.dis-detail .cur-s {
    cursor: pointer;
    /* text-align: center!important; */
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/DisDetail.vue